/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Scim_Token_Revoked_DescInputs */



/**
* | output |
* | --- |
* | "SCIM was disabled and its token revoked, so the identity provider can no longer manage members." |
*
* @param {Audit_Details_Scim_Token_Revoked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_scim_token_revoked_desc = /** @type {((inputs?: Audit_Details_Scim_Token_Revoked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Scim_Token_Revoked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM wurde deaktiviert und das Token widerrufen. Der Identitätsanbieter kann keine Mitglieder mehr verwalten.")
	return /** @type {LocalizedString} */ ("SCIM was disabled and its token revoked, so the identity provider can no longer manage members.")
});